module.exports = {
	'customFolder.m4.m410130_grid': {
		'courseName': '课程名称',
		'courseClassification': '课程分类',
		'modeOfDelivery': '上课方式',
		'typeOfTraining': '训练种类',
		'classTime': '上课时间',
		'courseHours': '课程时数',
		'learningStatus': '学习状态',
	},
	'customFolder.m4.m410130': {
		'manifestMode': '清单模式',
		'chartMode': '图表模式',
	},
	'customFolder.m4.m410130_chart': {
		'anOverviewOfLearningRecords': '学习纪录总览',
		'hours': '时数',
		'hall': '堂',
		'totalPeople': '共 <%=temp1%> 人',
		'noData': '无资料',
	},
	'customFolder.m4.m410130_browse': {
		'courseRequirements': '课程需求',
		'organizers': '主办单位',
		'instructorSName': '讲师姓名',
		'trainingLocation': '训练地点',
		'credit': '学分',
		'quizScores': '测验分数',
		'quizResults': '测验结果',
		'reasonForNonConformity': '不合格原因',
		'costSharingCorporate': '费用分摊(公司)',
		'costSharingEmployees': '费用分摊(员工)',
		'theDurationOfTheContractFor': '工作签约期限',
		'theExpirationDateOfTheJob': '工作签约到期日',
		'tempYears': '<%=temp1%> 年',
		'tempMonth': ' <%=temp1%> 月',
		'tempYearsAndMonths': '<%=temp1%> 年 <%=temp2%> 月',
		'hour': '小時',
		'credits': '学分',
		'divide': '分',
	},
	'customFolder.service.m3.service-m310240': {
		'aBreakdownOfTheDepartmentS': '部属学习纪录明细表',
	},
};
